module.exports = __webpack_public_path__ + "static/img/index_service_4.07f9443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SHscreen/index_service_4.png
// module id = yaCr
// module chunks = 4